import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-900 py-12 px-4 text-center" data-id="element-91">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-92">
        <span className="font-bold text-xl tracking-tight text-slate-500 mb-6" data-id="element-93">
          El Interruptor de Nitrógeno
        </span>

        <p className="text-slate-600 text-sm mb-4" data-id="element-94">
          © 2026 - Todos los derechos reservados.
        </p>

        <p className="text-slate-700 text-xs max-w-2xl leading-relaxed" data-id="element-95">
          Descargo de responsabilidad: Este producto es un protocolo de
          ejercicios y respiración. No es un medicamento. Los resultados pueden
          variar. Consulta con tu médico si tienes condiciones preexistentes.
          Este producto no diagnostica, trata, cura ni previene ninguna
          enfermedad.
        </p>
      </div>
    </footer>;
}